import {
	ChangeDetectionStrategy,
	Component,
	Input,
	ViewChild,
} from '@angular/core';

import { IbCoreCommonUtils } from 'ib/internetbank-core/utils/ib-common-utils';

import AltLinksUtils from '../../../common/utils/alt-link-utils';
import { TooltipPopupComponent } from '../../../ui/controls/tooltip-popup/tooltip-popup.component';
import { InsuranceDetail } from '../insurance';

@Component({
	selector: 'app-insurance-vertical-menu',
	templateUrl: './insurance-vertical-menu.component.html',
	styleUrls: ['./insurance-vertical-menu.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class InsuranceVerticalMenuComponent {

	@ViewChild(TooltipPopupComponent)
	public tooltipPopup: TooltipPopupComponent;

	@Input()
	public detailInfo: InsuranceDetail;


	constructor() { }

	public openPdf() {
		AltLinksUtils.openLinkIntoNewWindow(IbCoreCommonUtils.fromBase64ToObjectUrl(this.detailInfo.insurancePolicyDoc, 'application/pdf'));
	}

	public openTooltip(): void {
		this.tooltipPopup.open();
	}
}
